import React from 'react'
import * as Sentry from '@sentry/react';
import { required, requiredSelect } from '../../../validators/reclamationValidator';
import { Box, Button, File, FormTextarea, FormSelect, FormDatePicker } from '../../../common';
import { formatFileSize, MAX_FILE_SIZE, MAX_TOTAL_FILES_SIZE } from '../../../common/attachments';
import { Field } from 'react-final-form';

const DefectInformationSection = ({
  categoriesNames,
  files,
  fileErrors,
  isPreparingFiles,
  submitError,
  fileInput,
  handleFileChange,
  handleChooseFileClick,
  handleRemoveFileClick
}) => {

  const handleTestSentry = () => {
    try {
      // Testovací chyba pro Sentry
      throw new Error('Test Sentry error - kontrola funkčnosti error trackingu');
    } catch (error) {
      Sentry.captureException(error, {
        tags: {
          test: true,
          component: 'DefectInformationSection',
        },
        extra: {
          testContext: 'Testovací chyba z tlačítka',
        },
      });
      alert('Testovací chyba byla odeslána do Sentry!');
    }
  };

  const renderFileHandler = () => {
    return (
      <div className='form-group'>
        <input
          type="file"
          accept=".xls,.xlsx,.doc,.docx,.pdf,.png,.jpg,.jpeg,.svg"
          className="hiddenInput"
          ref={fileInput}
          onChange={handleFileChange}
          value={""}
          multiple={true}
          hidden={true}
        />

        <p className='attachments-hint'>
          Přiložit můžete fotografie (JPG, PNG) a dokumenty (PDF, Word, Excel). Fotografie před odesláním
          automaticky zmenšíme. Jeden soubor může mít nejvýše {formatFileSize(MAX_FILE_SIZE)},
          všechny přílohy dohromady nejvýše {formatFileSize(MAX_TOTAL_FILES_SIZE)}.
        </p>

        {(files.length)
          ? <div className="files">
            {files.map((file, index) => (
              <File fileName={file.name} filePath={file.name} key={index} link={false}>
                <Button className='trash_button' onClick={() => handleRemoveFileClick(index)} />
                <span className='attachments-size'>{formatFileSize(file.size)}</span>
              </File>
            ))}
          </div>
          : <p>Žádné přiřazené soubory</p>}

        {fileErrors.map((error, index) => <p key={index} className='attachments-error'>{error}</p>)}

        <button
          onClick={handleChooseFileClick}
          type="button"
          className='file-select__btn btn btn-primary'
          disabled={isPreparingFiles}
        >
          {isPreparingFiles ? 'Připravuji soubory…' : '+ Přidat soubor'}
        </button>
      </div>
    );
  }
  return (
    <Box>
      <h3 className="h3-reclamaction">Závada</h3>
      <div className='row'>
        <div className='col-md-4'>
          <Field
            name='datumZjisteni'
            type='date'
            component={FormDatePicker}
            label='Datum zjištění závady'
            validate={required}
          />
        </div>
        <div className='col-md-4'>
          <Field
            name='kategorie'
            component={FormSelect}
            label='Kategorie závady'
            items={[
              { name: 'Prosím vyberte' },
              ...categoriesNames,
            ]}
            validate={requiredSelect}
          />
        </div>
        <div className='col-md-4'>
          <Field
            name='prohlidka'
            component={FormDatePicker}
            label='Návrh termínu prohlídky (8 – 17h)'
            type='time'
            validate={required}
          />
        </div>
      </div>
      <div className='row'>
        <Field
          name='zavada'
          component={FormTextarea}
          label='Popište prosím závadu'
          validate={required}
        />
      </div>
      <h3 className="h3-reclamaction">Fotografie reklamované závady</h3>

      <div className='row col-md-12'>
        {renderFileHandler()}
      </div>
      <div className='summary'>
        <div className='row'>
          <div className='col-md-12'>
            {submitError && (
              <div className='attachments-error submit-error' role='alert'>
                <strong>Reklamaci se nepodařilo odeslat.</strong> {submitError}<br />
                Vyplněné údaje i přílohy zůstaly zachovány, reklamaci můžete odeslat znovu.
              </div>
            )}
            <button type='submit' className='btn btn-primary submit_btn btn-font' disabled={isPreparingFiles}>Odeslat reklamaci</button>
          </div>
          <div className='col-md-12'>
            <p className='small-note'><small>Odesláním souhlasíte se zpracováním osobních údajů pro vytvoření reklamace.</small></p>
            <button 
              type='button' 
              onClick={handleTestSentry}
              className='btn btn-secondary'
              style={{ fontSize: '10px', padding: '1px', display: 'none' }}
            >
              s
            </button>
          </div>
        </div>
      </div>
    </Box>
  )
}

export default DefectInformationSection
